/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteRequest } from 'relay-runtime';
export type Top500ListDisplayQueryVariables = {|
  contestId: string,
  playerId?: ?string,
|};
export type Top500ListDisplayQueryResponse = {|
  +top500SummaryForContest: ?$ReadOnlyArray<?{|
    +lineupId: string,
    +lineupNum: number,
    +totalLineups: number,
    +lineupScore: any,
    +numMadeCut: number,
    +salaryTot: number,
    +draftkingsUser: {|
      +username: string
    |},
  |}>
|};
export type Top500ListDisplayQuery = {|
  variables: Top500ListDisplayQueryVariables,
  response: Top500ListDisplayQueryResponse,
|};
*/


/*
query Top500ListDisplayQuery(
  $contestId: ID!
  $playerId: ID
) {
  top500SummaryForContest(contestId: $contestId, playerId: $playerId) {
    lineupId
    lineupNum
    totalLineups
    lineupScore
    numMadeCut
    salaryTot
    draftkingsUser {
      username
      id
    }
    id
  }
}
*/

const node/*: ConcreteRequest*/ = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "contestId"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "playerId"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "contestId",
    "variableName": "contestId"
  },
  {
    "kind": "Variable",
    "name": "playerId",
    "variableName": "playerId"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "lineupId",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "lineupNum",
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "totalLineups",
  "storageKey": null
},
v5 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "lineupScore",
  "storageKey": null
},
v6 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "numMadeCut",
  "storageKey": null
},
v7 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "salaryTot",
  "storageKey": null
},
v8 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "username",
  "storageKey": null
},
v9 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "Top500ListDisplayQuery",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "DraftKingsContestLineupType",
        "kind": "LinkedField",
        "name": "top500SummaryForContest",
        "plural": true,
        "selections": [
          (v2/*: any*/),
          (v3/*: any*/),
          (v4/*: any*/),
          (v5/*: any*/),
          (v6/*: any*/),
          (v7/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "DraftKingsUserType",
            "kind": "LinkedField",
            "name": "draftkingsUser",
            "plural": false,
            "selections": [
              (v8/*: any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "Top500ListDisplayQuery",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "DraftKingsContestLineupType",
        "kind": "LinkedField",
        "name": "top500SummaryForContest",
        "plural": true,
        "selections": [
          (v2/*: any*/),
          (v3/*: any*/),
          (v4/*: any*/),
          (v5/*: any*/),
          (v6/*: any*/),
          (v7/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "DraftKingsUserType",
            "kind": "LinkedField",
            "name": "draftkingsUser",
            "plural": false,
            "selections": [
              (v8/*: any*/),
              (v9/*: any*/)
            ],
            "storageKey": null
          },
          (v9/*: any*/)
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "f3e8f35a5a0505dcfd3382188625fd4b",
    "id": null,
    "metadata": {},
    "name": "Top500ListDisplayQuery",
    "operationKind": "query",
    "text": "query Top500ListDisplayQuery(\n  $contestId: ID!\n  $playerId: ID\n) {\n  top500SummaryForContest(contestId: $contestId, playerId: $playerId) {\n    lineupId\n    lineupNum\n    totalLineups\n    lineupScore\n    numMadeCut\n    salaryTot\n    draftkingsUser {\n      username\n      id\n    }\n    id\n  }\n}\n"
  }
};
})();
// prettier-ignore
(node/*: any*/).hash = '8f8bec1124d0eb880151e365928a62bb';

module.exports = node;
